// extracted by mini-css-extract-plugin
export default {"header":"header_header__A7NEZ","navContainer":"header_navContainer__OiimF","logo":"header_logo__TmkQW","logoT":"header_logoT__8IMcy","menuButton":"header_menuButton__K+603"};